import { render, staticRenderFns } from "./Modelos.vue?vue&type=template&id=5d6f5a4c&scoped=true"
import script from "./Modelos.vue?vue&type=script&lang=js"
export * from "./Modelos.vue?vue&type=script&lang=js"
import style0 from "./Modelos.vue?vue&type=style&index=0&id=5d6f5a4c&prod&lang=scss&scoped=true"
import style1 from "./Modelos.vue?vue&type=style&index=1&id=5d6f5a4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6f5a4c",
  null
  
)

export default component.exports